module.exports = __webpack_public_path__ + "static/img/kefu.6e7a702b.png";